import {Component, Input} from '@angular/core';
import {FormHelperService} from '../../../services/form-helper.service';
import {CustomFormControl} from '../CustomFormControl';

@Component({
  selector: 'app-ssn-input',
  templateUrl: './ssn-input.component.html',
  styleUrls: ['./ssn-input.component.scss']
})
export class SsnInputComponent {

  @Input() control!: CustomFormControl;
  ssn = '';
  isHidden = true;

  constructor(public formHelper: FormHelperService) {

  }

  onInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    this.ssn = inputElement.value.replace(/\D/g, '');
    this.control.setValue(this.formatSSN(this.ssn), { emitEvent: false });
  }

  onBlur(): void {
    this.isHidden = true;
  }

  onFocus(): void {
    this.isHidden = false;
  }

  formatSSN(value: string): string {
    const rawValue = value.replace(/\D/g, ''); // Remove non-digit characters

    if (rawValue.length <= 3) {
      return rawValue;
    } else if (rawValue.length <= 5) {
      return `${rawValue.slice(0, 3)}-${rawValue.slice(3)}`;
    } else {
      return `${rawValue.slice(0, 3)}-${rawValue.slice(3, 5)}-${rawValue.slice(5)}`;
    }
  }

  formatMaskedSsn(ssn: string): string {
    let copy = ssn.replace(/\D/g, '');

    if (copy.length >= 6) {
      copy = 'X'.repeat(5) + copy.substr(5);
    } else if (copy.length > 0) {
      copy = 'X'.repeat(copy.length - 1) + copy.substr(-1);
    }

    if (copy.length >= 6) {
      copy = copy.slice(0, 3) + '-' + copy.slice(3, 5) + '-' + copy.slice(5);
    } else if (copy.length >= 4) {
      copy = copy.slice(0, 3) + '-' + copy.slice(3);
    }

    return copy.slice(0, 11);
  }

}
